import React from 'react';

export default function Video({
    src,
    title,
    texts,
    autoplay=false,
    loop=false,
}) {
    return (
        <div className="video">
            <div className="content">
                <h2>{title}</h2>
                <video
                    src={src}
                    controls
                    autoPlay={autoplay}
                    loop={loop}
                ></video>
                <ul>
                    {texts.map((text, index) => (
                        <li key={index}>{text}</li>
                    ))}
                </ul>
            </div>
        </div>
    )
}


